import script from "./SelectGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectGroup.vue?vue&type=script&setup=true&lang=js"

import "./SelectGroup.vue?vue&type=style&index=0&id=06686d47&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06686d47"]])

export default __exports__